import { ButtonView, env, Plugin } from 'ckeditor5';

const pageBreakLineIcon =
  '<svg xmlns="http://www.w3.org/2000/svg" data-dc-tpl="17" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">\n' +
  '          <rect data-dc-tpl="18" fill="none" x="5" y="3" width="14" height="18" rx="2"></rect>\n' +
  '          <line data-dc-tpl="19" fill="none" x1="8" y1="7" x2="16" y2="7"></line>\n' +
  '          <line data-dc-tpl="20" fill="none" x1="8" y1="9.4" x2="13.5" y2="9.4"></line>\n' +
  '          <line data-dc-tpl="21" fill="none" x1="8" y1="14.6" x2="16" y2="14.6"></line>\n' +
  '          <line data-dc-tpl="22" fill="none" x1="8" y1="17" x2="13" y2="17"></line>\n' +
  '          <line data-dc-tpl="23" fill="none" x1="3.2" y1="12" x2="19" y2="12" stroke-dasharray="2 2"></line><text data-dc-tpl="24" x="21.7" y="12" font-size="4" font-weight="600" text-anchor="middle" dominant-baseline="central" fill="currentColor" stroke="none" font-family="sans-serif">2</text>\n' +
  '        </svg>';
const PAGINATION_PREVIEW_ENABLED_STORAGE_KEY =
  'qualio-pagination-preview-enabled';

export class QualioPaginationTogglePlugin extends Plugin {
  static get pluginName(): string {
    return 'QualioPaginationTogglePlugin';
  }

  static readonly toolbarButtonName = 'qualioPaginationToggle';

  init(): void {
    const editor = this.editor;

    const isBrowserSupported =
      env.isBlink ||
      editor.config.get('pagination.enableOnUnsupportedBrowsers');

    const paginationEditing = editor.plugins.get('PaginationEditing') as any;

    const wasEnabledLastSession =
      localStorage.getItem(PAGINATION_PREVIEW_ENABLED_STORAGE_KEY) === 'true';

    const startEnabled = Boolean(isBrowserSupported) && wasEnabledLastSession;

    this.set('isPaginationPreviewEnabled', startEnabled);

    // The Pagination plugin enables itself automatically once the editor is
    // ready. Force it off on startup unless the user previously opted in via
    // the toggle button, so pagination previews only turn on when wanted.
    if (!startEnabled) {
      paginationEditing.forceDisabled(QualioPaginationTogglePlugin.pluginName);
    }

    editor.ui.componentFactory.add(
      QualioPaginationTogglePlugin.toolbarButtonName,
      (locale) => {
        const view = new ButtonView(locale);

        view.set({
          label: 'Show pagination previews',
          icon: pageBreakLineIcon,
          tooltip: isBrowserSupported
            ? true
            : 'Pagination previews are not available on Firefox or Safari',
          isToggleable: true,
          isEnabled: isBrowserSupported,
        });

        view.bind('isOn').to(this, 'isPaginationPreviewEnabled');

        view.on('execute', () => {
          if (!isBrowserSupported) {
            return;
          }

          this.isPaginationPreviewEnabled = !this.isPaginationPreviewEnabled;

          localStorage.setItem(
            PAGINATION_PREVIEW_ENABLED_STORAGE_KEY,
            String(this.isPaginationPreviewEnabled),
          );

          if (this.isPaginationPreviewEnabled) {
            paginationEditing.clearForceDisabled(
              QualioPaginationTogglePlugin.pluginName,
            );
          } else {
            paginationEditing.forceDisabled(
              QualioPaginationTogglePlugin.pluginName,
            );
          }
        });

        return view;
      },
    );
  }
}

export interface QualioPaginationTogglePlugin {
  isPaginationPreviewEnabled: boolean;
}
